import { create } from 'zustand';
import type { AuthState, AuthActions } from './types';

interface AuthStore extends AuthState, AuthActions {}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  isLoading: false,
  isAuthenticated: false,
  loginAttempts: 0,
  lastLoginError: null,

  setUser: (user) => set({ user, isAuthenticated: !!user }),
  setLoading: (isLoading) => set({ isLoading }),
  setAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
  incrementLoginAttempts: () =>
    set((state) => ({ loginAttempts: state.loginAttempts + 1 })),
  resetLoginAttempts: () => set({ loginAttempts: 0 }),
  setLoginError: (lastLoginError) => set({ lastLoginError }),
  logout: () =>
    set({
      user: null,
      isAuthenticated: false,
      loginAttempts: 0,
      lastLoginError: null,
    }),
}));